<mat-card style="float: left;clear: both">
  <mat-card-actions>
    <a routerLink="/proposals">Propostes amb "Pendent de contracte"</a>&nbsp;
    <span *ngIf="rol == 2 || rol == 4" (click)="createProposal()" style="text-decoration:underline;cursor:pointer;margin-left:10px"><u>Nova</u></span>
    <span (click)="viewAllProposals()" style="text-decoration:underline;cursor:pointer;margin-left:20px"><u>Veure'n més</u></span>
  </mat-card-actions>
  <mat-card-content *ngIf="activeProposals.length">
    <mat-list-item  style="cursor:pointer" *ngFor="let proposal of activeProposals; let i = index;" (click)="navigateToProposal(proposal)">
      <p mat-line style="font-weight:bold">
        {{proposal.titol}}
      </p>
      <p mat-line>
        Deadline: {{proposal.data_limit_presentacio}}
        <span *ngIf="proposal.data_documentacio" style="margin-left:40px">Limit requeriment: {{proposal.data_documentacio}}</span>
        <span *ngIf="proposal.personal_id" style="margin-left:40px">Coordinació {{proposal.name}}</span>
      </p>
      <h3 mat-line style="padding-bottom: 15px">
        <span style="margin-left: 0px;float: left;clear: none;padding-right: 5px">
              <span *ngIf="proposal.alerta_redaccio == 2" style="width:15px;float:left;font-size:14px">
                <mat-icon style="color: red;font-size:14px" title="En redacció desprès 3 mesos finalització">alarm_off</mat-icon>
              </span>
              <span *ngIf="proposal.alerta_redaccio == 1" style="width:15px;float:left;font-size:14px">
                <mat-icon style="color: orange;font-size:14px" title="En redacció desprès 6 mesos finalització">alarm_off</mat-icon>
              </span>
              <span *ngIf="proposal.alerta_redaccio !== 1 && proposal.alerta_redaccio !== 2" style="width:15px;float:left;font-size:14px">
                <mat-icon style="color: green;font-size:14px" title="Estat proposta: {{proposal.estat_proposta}}.">alarm_off</mat-icon>
              </span>

              <span *ngIf="proposal.import_propi == null || proposal.import_propi < 0.1" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="No s'ha introduït l'import propi">monetization_on</mat-icon>
              </span>
              <span *ngIf="!(proposal.import_propi == null || proposal.import_propi < 0.1)" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="Import propi {{proposal.import_propi}}">monetization_on</mat-icon>
              </span>

              <span *ngIf="proposal.data_inici_possible == null" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="No s'ha introduït la data prevista d'inici">picture_in_picture_alt</mat-icon>
              </span>
              <span *ngIf="proposal.data_inici_possible !== null" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="Data prevista d'inici {{proposal.data_inici_possible}}">picture_in_picture_alt</mat-icon>
              </span>
              <span *ngIf="proposal.data_limit_presentacio == null" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="No s'ha introduït la data límit de presentació">view_timeline</mat-icon>
              </span>
              <span *ngIf="proposal.data_limit_presentacio !== null" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="Data límit de presentació {{proposal.data_limit_presentacio}}">view_timeline</mat-icon>
              </span>
        </span>

        <span *ngIf="proposal.ambit_proposta=='Europa'" style='color:#0000FF;font-size:1em'>{{proposal.clau}}</span>
        <span *ngIf="proposal.ambit_proposta=='Internacional'" style='color:#008800;font-size:1em'>{{proposal.clau}}</span>
        <span *ngIf="proposal.ambit_proposta=='Espanya'" style='color:#800000;font-size:1em'>{{proposal.clau}}</span>
        <span *ngIf="proposal.ambit_proposta=='Catalunya'" style='color:rgb(100,100,100);font-size:1em'>{{proposal.clau}}</span>
      </h3>
    </mat-list-item>
  </mat-card-content>
  <mat-card-content *ngIf="!activeProposals.length">
    <p mat-line>No tens cap proposta oberta</p>
  </mat-card-content>
</mat-card>
<mcrit-gestio-list-resume
  [dades]="resumeData" [titol]="'Àmbit de les propostes'" style="float: left;margin-top: 20px;clear: both;width: 100%;background-color:white;margin-bottom:20px">
</mcrit-gestio-list-resume>